import type { SVGProps } from "react";
const SvgChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M543.707 85.2929C544.098 85.6834 544.098 86.3166 543.707 86.7071L538.414 92L543.707 97.2929C544.098 97.6834 544.098 98.3166 543.707 98.7071C543.317 99.0976 542.683 99.0976 542.293 98.7071L536.293 92.7071C535.902 92.3166 535.902 91.6834 536.293 91.2929L542.293 85.2929C542.683 84.9024 543.317 84.9024 543.707 85.2929Z"
      fill="currentColor"
      transform="translate(-528 -80)"
    />
  </svg>
);
export default SvgChevronLeft;
